export default __webpack_public_path__ + "static/media/card1.7d50665a.svg";